export const numeric = [
    v => !isNaN(v) || null || "Numeric Required",
]

export const required = [
    v => !!v || "Required"
]

export const gtZero = [
    v => ((typeof v === 'string' && v.length === 0) || (v === null) || Math.abs(v) > 0) || "Must Be Greater Than Zero"
]

export const isRequired = (v, msg = "Required Field!") => !!v || msg;

export const isNumeric = (v, msg = "Numeric Required") => {
    if (!v) return true;
    return !isNaN(v) || msg;
}

export const isEmail = v => {
    if (!v) return true;
    return /.+@.+\..+/.test(v) || "Email not valid!";
}

export const isSmallImage = value => !value || value.size < 250000 || `Image size should be less than 250 KB!`